module.exports = __webpack_public_path__ + "static/04-7312d86b7e52f2e1014a72a2e7f8cce8.jpg";